import OnLoad from './on-load';

/**
 * handles onLoad lazy-load elements
 */
export default class Session extends OnLoad {
	static actionSelector = 'a[href^="#lazyLoad-Session="]';
	static actionSelectorExternal = 'a[href^="#lazyLoad-Session-"]';
	static actionName = '#lazyLoad-Session=';
	getSessionKey() {
		let { sessionKey = false } = this.data;
		return sessionKey || false;
	}

	shouldDisplay() {
		const sessionKey = this.getSessionKey();
		if ( ! sessionKey ) {
			return true;
		}

		let { sessionCount = 1 } = this.data;

		sessionCount *= 1; // ensure number
		let currentCount = parseInt( window.sessionStorage.getItem( sessionKey ) ) || 0;
		return currentCount < sessionCount;
	}

	addListener() {
		if ( ! this.shouldDisplay() ) {
			return;
		}
		super.addListener();
	}

	static getActionData( a ) {
		// maybe hide element
		const href = a.getAttribute( 'href' );

		if ( ! href ) {
			return false;
		}
		let data = decodeURIComponent( href ).split( this.actionName );
		if ( ! data?.[1] ) {
			return false;
		}
		let json = data[1].replace( /\+/g, ' ' );
		return JSON.parse( atob( json ) ) || false;
	}

	/**
	 * used to hide and/or show elements after action
	 * @param a HTMLElement
	 */
	static maybeHideShowElement( a ) {
		// maybe hide element
		const data = Session.getActionData( a );
		if ( ! data ) {
			return;
		}

		if ( data?.hideSelector ) {
			document.querySelectorAll( data.hideSelector ).forEach( e => e.style.display = 'none' );
		}
		if ( data?.showSelector ) {
			document.querySelectorAll( data.showSelector ).forEach( e => e.style.display = 'block' );
		}
	}

	static updateSessionCount( sessionKey ) {
		let currentCount = parseInt( window.sessionStorage.getItem( sessionKey ) ) || 0;
		window.sessionStorage.setItem( sessionKey, currentCount + 1 );
	}

	static handleSession( e, externalSession = false ) {
		e.preventDefault();
		e.stopPropagation();
		let a = e.target;
		if ( a.tagName !== 'A' ) {
			a = a.closest( 'a' );
		}
		let sessionKey = externalSession || false;
		Session._sessionHandler( a, sessionKey );
	}

	handleSessionInstance( e ) {
		e.preventDefault();
		e.stopPropagation();
		const a = e.target;
		let sessionKey = this.getSessionKey() || false;
		Session._sessionHandler( a, sessionKey );
	}

	static _sessionHandler( a,  sessionKey ) {
		if ( ! sessionKey ) {
			const data = Session.getActionData( a );
			if ( ! data || ! data?.sessionKey ) {
				return;
			}
			sessionKey = data.sessionKey;
		}
		Session.updateSessionCount( sessionKey );
		Session.maybeHideShowElement( a );
	}

	afterInsert() {
		this.element.querySelectorAll( self.actionSelector ).forEach( ( a ) => {
			const handler = ( e ) => {
				this.handleSessionInstance( e );
				// remove after one time
				a.removeEventListener( 'click', handler );
			}
			a.addEventListener( 'click', handler );
		} );
		return super.afterInsert();
	}
}
